export default __webpack_public_path__ + "static/media/MasterCAM.98126569.svg";